var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBack2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM10.5625 6.00879C10.0939 5.54051 9.33476 5.54046 8.86621 6.00879L6.58008 8.29492C6.11181 8.76348 6.11182 9.52265 6.58008 9.99121L8.86621 12.2773C9.33478 12.7455 10.094 12.7456 10.5625 12.2773C11.0311 11.8088 11.0309 11.0487 10.5625 10.5801L10.3252 10.3428H13.1426C14.3732 10.3429 15.3709 11.3407 15.3711 12.5713C15.3709 13.8019 14.3732 14.7997 13.1426 14.7998H9.71484C9.0522 14.7998 8.5148 15.3374 8.51465 16C8.5148 16.6626 9.05219 17.2002 9.71484 17.2002H13.1426C15.6987 17.2001 17.7713 15.1274 17.7715 12.5713C17.7713 10.0152 15.6987 7.94344 13.1426 7.94336H10.3252L10.5625 7.70605C11.0311 7.2375 11.0309 6.47744 10.5625 6.00879Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBack2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Back2.e9963eb03a1964614251ce8ee8255d18.svg";